import React, { useState, useEffect } from "react";
import "./price.css";
import { useNavigate } from "react-router-dom";
import SignupPopup from "../SignupPopup";
import UpgradePopupWithoutLogin from "../WithoutLoginPaypal";
import UpgradePopupWithLogin from "../WithLoginPaypal";
import { fetchMasterlist } from "../../api/api";

export default function PricingPlans({ setToken, token }) {
  const [showPopupSignup, setShowPopupSignup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [showPopupWithoutlogin, setShowPopupWithoutlogin] = useState(false);
  const [showPopupWithlogin, setShowPopupWithlogin] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [subscription, setSubscription] = useState([]);
  const [successMessagePrice, setSuccessMessagePrice] = useState(false);
  const [loading, setLoading] = useState(true);
  const storedLoginData = sessionStorage.getItem("loginData");
  const parsedLoginData = storedLoginData ? JSON.parse(storedLoginData) : {};
    
  const handleClose = () => setShowPopupSignup(false);
  const handleCloseWithoutlogin = () => setShowPopupWithoutlogin(false);
  const handleCloseWithlogin = () => setShowPopupWithlogin(false);

  const handleUpgradeClick = () => {
    if (!selectedPlan.subscriptionid) {
      setError("⚠️ Please select a plan before upgrading.");
      return;
    }
    setError("");

    if (token && selectedPlan.productid) {
      setShowPopupWithlogin(true);
    } else if (selectedPlan.productid) {
      setShowPopupWithoutlogin(true);
    }
  };

  useEffect(() => {
    const loadSubscription = async () => {
      setLoading(true)
      try {
        const response = await fetchMasterlist();
        if (response && Array.isArray(response.data.subscriptions)) {
          setSubscription(response.data.subscriptions);
          setLoading(false)

        } else {
          console.error("Invalid country response:", response);
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };

    loadSubscription();
  }, []);

  useEffect(() => {
  if (successMessagePrice) {
    setToken(null)
    const timer = setTimeout(() => {
      setShowPopupSignup(true);
  }, 3000);

    return () => clearTimeout(timer);
  }
  }, [successMessagePrice, setToken]);

  return (
    <div className="pricing-container">
      <h2 className="title">Choose your plan – build smarter bets today</h2>
      {successMessagePrice && (
        <p className="success-text">
          ✅ You’re ready to go! Log back in to unlock your Pro features.
        </p>
      )}

      <div className="plans">
        {/* Free Plan */}
        <div className="plan free-plan">
          <div className="plan-header">
            <h3>Free Plan</h3>
            <p className="subtext">Always Free</p>
          </div>
          <ul>
            <li>Instant Bet only (no Build Your Bet mode)</li>
            <li>Limited leagues in Best Bets Builder (EPL only)</li>
            <li>
              Multibet: 6 fixed multiples from Win Amount filters (no leg
              replacement)
            </li>
            <li>Treble Win: EPL + 3 core markets only</li>
          </ul>
          <button
            className="btn-price free-btn"
            onClick={() => token ? navigate('/') : setShowPopupSignup(true)}
          >
            Continue Free – Start Now
          </button>
        </div>

        {/* Pro Plan */}
        <div className="plan pro-plan">
          <div className="plan-header">
            <h3>Pro Plan</h3>
            <p className="subtext">£4.99/month or £1.99/week</p>
          </div>
          {/* <div className="plan-header">
            <p className="subtext-free">Monthly plan includes a 7-day free trial</p>
          </div> */}
          <ul>
            <li>Build Your Bet mode unlocked</li>
            <li>
              All leagues in Best Bets Builder (Big 5, Brazil, MLS, Argentina)
            </li>
            <li>Multibet: full filters + replace leg option</li>
            <li>Treble Win: all leagues + full market list</li>
            <li>Bet grading (0–10)</li>
            <li>Cancel anytime via PayPal</li>
          </ul>

          {/* Plan options */}
          <div className="plan-options">
            {loading
              ? // Skeleton placeholders (3 placeholders)
                Array.from({ length: 3 }).map((_, i) => (
                  <div key={i} className="plan-skeleton"></div>
                ))
              : subscription
                  .filter((plan) => plan.isactive && plan.paypalplanid)
                  .map((plan) => {
                    // Split activepaypalplanids into array
                    const activePlanIds = parsedLoginData.activepaypalplanids
                      ? parsedLoginData.activepaypalplanids.split(",")
                      : [];

                    // Check if current plan is one of the active ones
                    const isDisabled = activePlanIds.includes(plan.paypalplanid);

                    return (
                      <button
                        key={plan.subscriptionid}
                        className={`plan-btn ${
                          selectedPlan?.subscriptionid === plan.subscriptionid ? "active" : ""
                        } ${isDisabled ? "disabled-plan" : ""}`}
                        onClick={() =>
                          setSelectedPlan({
                            subscriptionid: plan.subscriptionid,
                            productid: plan.productid,
                            paypalplanid: plan.paypalplanid,
                          })
                        }
                        disabled={isDisabled}
                      >
                        <span className="plan-name">{plan.subscription}</span>
                        <span className="plan-price">(£ {plan.sterlingprice})</span>
                      </button>
                    );
                  })}
          </div>


            {error && <p className="field-error-upgradelogin">{error}</p>}

            <button
              className="btn-price pro-btn"
              onClick={handleUpgradeClick}
              disabled={!selectedPlan || loading}
            >
              {loading ? "Loading Plans..." : "Upgrade to Pro with PayPal"}
            </button>
        </div>
      </div>

      {/* Footer notes */}
      <div className="footer-notes">
        {/* <p>🆓 Free trial available on the monthly plan only. One trial per PayPal account.</p> */}
        <p>🔒 All subscriptions are handled securely by PayPal.</p>
        <p>🔄 Subscriptions auto-renew until cancelled. Cancel anytime via PayPal.</p>
        <p>⚠️ 18+ only. Please gamble responsibly.</p>
      </div>

      {/* Signup Popup (Free plan) */}
      {(showPopupSignup || successMessagePrice) && (
        <SignupPopup
          showPopup={showPopupSignup}
          handleClose={handleClose}
          setToken={setToken}
          hederLogin={successMessagePrice ? true : false}
        />
      )}

      {showPopupWithoutlogin && (
        <UpgradePopupWithoutLogin
          show={showPopupWithoutlogin}
          handleClose={handleCloseWithoutlogin}
          selectedPlan={selectedPlan}
          setToken={setToken}
          setSuccessMessagePrice={setSuccessMessagePrice}
        />
      )}

      {showPopupWithlogin && token && (
        <UpgradePopupWithLogin
          show={showPopupWithlogin}
          handleClose={handleCloseWithlogin}
          selectedPlan={selectedPlan}
          setSuccessMessagePrice={setSuccessMessagePrice}
        />
      )}
    </div>
  );
}
